import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';

const ViewModal = (props) => {

    const [inputAdminTitle, setInputAdminTitle] = useState("");

    useEffect(() => {
        if (props.data) {
            setInputAdminTitle("View Email Template");
        }
    }, [props]);

    return (
        props.open && (
            <Modal show={props.open} onHide={props.close}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title">{inputAdminTitle}</Modal.Title>
                    <Button variant="outline-danger" onClick={props.close}><i className="fa fa-close"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="modal-body">
                        <div className="form-group">
                            <div className="row">
                                <label>Subject : </label>
                                <p> {props?.data?.subject}</p>
                            </div>
                            <div className="row">
                                <label>Email Type : </label>
                                <p> {props?.data?.email_type}</p>
                            </div>
                            <div className="row">
                                <label>Content : </label>
                                <div dangerouslySetInnerHTML={ { __html: props?.data?.content}} />
                                {/* <p> { props?.data?.content }</p> */}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    );
}

export default ViewModal;
